import axios from 'axios';
import appConfig from './configs/appConfig';


axios.defaults.xsrfHeaderName = 'X-CSRFToken';
axios.defaults.xsrfCookieName = 'csrftoken';

export const hhAxios = axios.create({
  baseURL: 'https://api.hh.ru/',
  timeout: 60000,
});

const apiAxios = axios.create({
  baseURL: appConfig.API_URL,
  timeout: 60000,
  xsrfHeaderName: 'X-CSRFToken',
  xsrfCookieName: 'csrftoken',
});

export default apiAxios;
